import CombatantModel from "./models/CombatantModel.js";
import { attackList } from "./PlayerFixture_combatant";
import { sampleLoadouts } from "../Fixture_combatants.js";

export function getDevScenario(controlledCombatantIds) {
  return {
    main: new CombatantModel({
      //...sampleLoadouts[0], //was ...getRandomLoadout(),
      ...sampleLoadouts[4],
      name: "PLAYER",
      skinId: "skin_m1",
      wantsToJoinTeam: "one",
      //isBot: true,
      hp: 20,
      // pp: 2,
      // attackModifier: 99,
      // defenseModifier: 999,
      speedModifier: 10,
      // accuracyModifier: -100,
      dangerMeter: 100,

      // status: "lag",

      arenaPosition: 1,
      attacks: [...attackList],
      items: [
        { actionId: "item_revive", instanceId: "instance_asdasdas" },
        { actionId: "item_full-revive", instanceId: "instance_asdasdas2" },
        {
          actionId: "item_team-danger-boost",
          instanceId: "instance_asdasdas2b",
          isBugged: false
        },
        {
          actionId: "item_danger-boost",
          instanceId: "instance_asdasdas3",
          isBugged: false
        },
        {
          actionId: "item_max-danger-boost",
          instanceId: "instance_asdasdas4",
          isStolen: true
        },
        {
          actionId: "item_mini-battery-pack",
          instanceId: "instance_asdasdas5",
          isBugged: false
        },
        // {
        //   actionId: "item_network-reset-code",
        //   instanceId: "instance_asdasdas5"
        // }
      ]
    }),
    oneB: new CombatantModel({
      ...sampleLoadouts[1],
      name: "Andre",
      skinId: "skin_f1",
      //hp: -4,
      // status: "lag",

      //Only be a bot if ID does not show up in controlledCombatantIds
      isBot: !controlledCombatantIds.includes("oneB"), //true,

      wantsToJoinTeam: "one",
      arenaPosition: 2,
      items: []
    }),
    oneC: new CombatantModel({
      ...sampleLoadouts[4],
      name: "Biff",
      skinId: "skin_m2",

      //Only be a bot if ID does not show up in controlledCombatantIds
      isBot: !controlledCombatantIds.includes("oneC"), //true,

      wantsToJoinTeam: "one",
      hp: -1,
      arenaPosition: 3,
      items: []
    }),

    /* ENEMY **************************************************************************************************************************** */

    twoA: new CombatantModel({
      ...sampleLoadouts[3],
      name: "Cassandra",
      skinId: "skin_f3",
      isBot: true,

      // speedModifier: 999,
      // defenseModifier: 999,
      // hp: -1,
      // pp: 0,

      arenaPosition: 1,

      // attacks: [
      //   { actionId: "special_slice" },
      //   // { actionId: "special_ddos" },
      //   // { actionId: "special_copy-paste" },
      //   // { actionId: "special_scope-bomb" },
      //   // { actionId: "special_firewall" }
      //   // {actionId: "special_sql-drop"},
      // ],

      //status: "memory-leak",
      // speedModifier: 9999,
      //defenseModifier: 3,
      // isSelfServing: false,
      //speedModifier: 100,
      wantsToJoinTeam: "two",
      //dangerMeter: 100,
      //personalityObviousOpportunityRating: 100,
      // speedModifier: 100,
      // computerAiPersonality: {
      //   default: {
      //     vicious: 10
      //   }
      // },
      //   // goodTimes: {
      //   //   "thief": 1,
      //   // },
      //   // badTimes: {
      //   //   "recovering": 10,
      //   // },
      // },
      items: [
        { actionId: "item_revive", instanceId: "instance_asdasdas-a" },
        { actionId: "item_revive", instanceId: "instance_asdasdas-b" },
        { actionId: "item_revive", instanceId: "instance_asdasdas-c" },
        { actionId: "item_revive", instanceId: "instance_asdasdas-d" },
        { actionId: "item_revive", instanceId: "instance_asdasdas-e" }
      ]
      // hp: 10,
      // speedModifier: 99,
      // computerAiPersonality: {
      //   default: {
      //     "recovering": 10
      //   }
      // },
    }),
    twoB: new CombatantModel({
      ...sampleLoadouts[3],
      name: "Brooklyn",
      skinId: "skin_m1",
      isBot: true,
      wantsToJoinTeam: "two",
      arenaPosition: 2,
      status: "focus",
      // hp: -2,
      // items: [
      //   { actionId: "item_honeypot-trap", instanceId: makeId("itemInstance", 10), isStolen: false},
      // ]
    }),
    twoC: new CombatantModel({
      ...sampleLoadouts[3],
      name: "Betsy",
      skinId: "skin_f2",
      // hp: 0,
      isBot: true,
      wantsToJoinTeam: "two",
      arenaPosition: 3
      //status: "deadline"
      // items: [
      //   { actionId: "item_honeypot-trap", instanceId: makeId("itemInstance", 10), isStolen: false},
      // ]
    })
  };
}



// WEBPACK FOOTER //
// ./src/battle/getDevScenario.js